var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100vh","width":"100vw","margin":"0","padding":"0","overflow":"hidden"}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%","min-height":"700px"},attrs:{"src":"https://udify.app/chatbot/hkJnAvSzgwmVO6m2","frameborder":"0","allow":"microphone"}})])
}]

export { render, staticRenderFns }